module.exports = __webpack_public_path__ + "img/logo_50.40c4a025.png";